import React from "react";
import { DatePicker, Form } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../../utils/form";
import moment from "moment";
import { dateTimeToString } from "../../../utils/formatter";

function itemLayout(fullLabelWidth) {
  let layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      lg: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      lg: { span: 14 },
    },
  };

  if (fullLabelWidth === true) {
    layout.labelCol.lg.span = 24;
    layout.wrapperCol.lg.span = 24;
  }

  return layout;
}

const ControlledDatePicker = ({
  control,
  errors,
  name,
  label,
  format = null,
  showTime = false,
  required,
  minimum,
  maximum,
  disabled,
  fullLabelWidth = false,
}) => {
  const error = getError({ errors, name });

  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledDateTime = (current) => {
    if (current && current.isSame(moment(), "day")) {
      const currentHour = moment().hour();
      const currentMinute = moment().minute();
      const currentSecond = moment().second();
      const providedHour = current.format("HH");

      let disabledObj = {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).splice(currentHour + 1, 24),
      };
      if (providedHour == currentHour) {
        disabledObj = {
          ...disabledObj,
          disabledMinutes: () =>
            Array.from({ length: 60 }, (_, i) => i).splice(
              currentMinute + 1,
              60
            ),
          disabledSeconds: () =>
            Array.from({ length: 60 }, (_, i) => i).splice(
              currentSecond + 1,
              60
            ),
        };
      }
      return disabledObj;
    }

    // Return an empty object if the selected date is not today, meaning no times are disabled
    return {};
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          label={label}
          {...itemLayout(fullLabelWidth)}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <DatePicker
            {...field}
            format={format}
            showTime={showTime}
            disabledTime={disabledDateTime}
            style={{
              width: "100%",
            }}
            disabledDate={(d) => {
              if (
                !d ||
                (minimum && d.isBefore(minimum, "date")) ||
                (maximum && d.isAfter(maximum, "date"))
              )
                return true;
              //if (d.isSame(minimum, "date")) return false;
              else return false;
            }}
            disabled={disabled}
          />
        </Form.Item>
      )}
    />
  );
};

export default ControlledDatePicker;
